var fetchAbadHtml = function fetchAbadHtml(_ref) {
  return new Promise(function ($return, $error) {
    var abadClient, viewer;
    abadClient = _ref.abadClient, viewer = _ref.viewer;
    return Promise.resolve(abadClient.fetchHtml(viewer === null || viewer === void 0 ? void 0 : viewer.zuid)).then($return, $error);
  });
};

export default fetchAbadHtml;
//# sourceMappingURL=fetchAbadHtml.js.map